"use strict";
var import_base_64 = require("base-64");
var import_utils = require("../utils");
if (!global.btoa || (0, import_utils.isHermes)()) {
  global.btoa = import_base_64.encode;
}
if (!global.atob || (0, import_utils.isHermes)()) {
  global.atob = import_base_64.decode;
}
//# sourceMappingURL=base64Polyfill.js.map